// src/features/product/components/AddProductModal.jsx
import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select, { components } from "react-select";
import * as IoIcons from "react-icons/io5";
import * as FaIcons from "react-icons/fa";

const CategoriesModalAdd = ({
  show,
  handleClose,
  handleAddCategories,
  parsingDataEdit,
}) => {
  const [categories, setCategories] = useState({
    name: "",
    icon: "",
  });

  useEffect(() => {
    if (parsingDataEdit) {
      setCategories({
        name: parsingDataEdit.name,
        icon: parsingDataEdit.icon,
      });
    } else {
      setCategories({ name: "", icon: "" });
    }
  }, [parsingDataEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategories({ ...categories, [name]: value });
  };

  const handleSelectChange = (selectedOption) => {
    setCategories({
      ...categories,
      icon: selectedOption.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (parsingDataEdit != null) {
      handleAddCategories({ ...parsingDataEdit, ...categories });
    } else {
      handleAddCategories(categories);
    }
    setCategories({ name: "" });
    handleClose();
  };

  const options = Object.keys(FaIcons).map((key) => ({
    value: key,
    label: key,
    icon: FaIcons[key],
  }));

  const CustomOption = (props) => {
    const IconComponent = props.data.icon;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <IconComponent size={22} />
          <span>{props.data.label}</span>
        </div>
      </components.Option>
    );
  };

  const CustomSingleValue = (props) => {
    const IconComponent = props.data.icon;

    return (
      <components.SingleValue {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <IconComponent size={22} />
          <span>{props.data.label}</span>
        </div>
      </components.SingleValue>
    );
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Categories</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={categories.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Select
              name="icon"
              options={options}
              value={options.find((option) => option.value === categories.icon)}
              onChange={handleSelectChange}
              components={{
                Option: CustomOption,
                SingleValue: CustomSingleValue,
              }}
              placeholder="Select an icon..."
              menuPlacement="auto"
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CategoriesModalAdd;
